import {option} from "@components/Theme/Select/CustomSelect/CustomSelect"

export const Currencies = (): option[] => {
	return [
		{
			id: 0,
			title: "EUR (€)",
			slug: "eur",
		},
		{
			id: 1,
			title: "GBP (£)",
			slug: "gbp",
		},
		{
			id: 2,
			title: "SEK (kr)",
			slug: "sek",
		},
		{
			id: 3,
			title: "DKK (kr)",
			slug: "dkk",
		},
		{
			id: 4,
			title: "NOK (kr)",
			slug: "nok",
		},
		{
			id: 5,
			title: "ISK (kr)",
			slug: "isk",
		},
	]
}
